import axios from 'axios';
import { GET, POST } from '../../utils/axios-interceptor';
import { polusBaseUrl } from '../../utils/axios-interceptor';
import {
    UpdateLenderRequirementPayload,
    UpdateAicaChaseStatusPayload,
    UpdateLenderAicaChaseStatusPayload,
    AicaChaseStatus,
} from './NeedInfoV2Constants';

export const fetchLenderRequirements = (payload) => {
    return axios({
        url: API_ENDPOINTS.GET_LENDER_REQUIREMENTS,
        method: GET,
        params: payload,
    });
};

export const updateLenderRequirement = (payload: {
    id: number | string;
    updatedBy: string | undefined;
    dataType?: string;
    status?: 'PENDING' | 'COMPLETE';
}) => {
    return axios({
        url: API_ENDPOINTS.UPDATE_LENDER_REQUIREMENTS,
        method: POST,
        data: payload,
    });
};

export const updateLenderRequirementsBatch = (payload: {
    ids: (number | string)[];
    updatedBy: string | undefined;
    dataType?: string;
    status?: 'PENDING' | 'COMPLETE';
    isArchived?: boolean;
    isDeleted?: boolean;
    requirementFor?: string;
}) => {
    return axios({
        url: API_ENDPOINTS.UPDATE_LENDER_REQUIREMENTS,
        method: POST,
        data: payload,
    });
};

export const addLenderRequirement = (payload: any) => {
    return axios({
        url: API_ENDPOINTS.ADD_LENDER_REQUIREMENTS,
        method: POST,
        data: payload,
    });
};

export const refreshRequirementsAsOfToday = (payload: any, headers: any) => {
    return axios({
        url: API_ENDPOINTS.REFRESH_REQUIREMENTS_AS_OF_TODAY,
        method: POST,
        data: payload,
        headers: headers,
    });
};

export const populateRequestForPnoConfig = (payload: any) => {
    return axios({
        url: API_ENDPOINTS.POPULATE_REQUEST_FOR_PNO_CONFIG,
        method: POST,
        data: payload,
    });
};

export const fetchBorrorwerRequirements = ({ orgId, pnoId, isArchived }) => {
    return axios({
        url: API_ENDPOINTS.GET_BORROWER_REQUIREMENTS,
        method: GET,
        params: { orgId, pnoId, isArchived },
    });
};

export const updateAicaChaseStatus = (payload: UpdateAicaChaseStatusPayload) => {
    return axios({
        url: API_ENDPOINTS.UPDATE_AICA_CHASE_STATUS,
        method: POST,
        data: payload,
    });
};

export const updateLenderAicaChaseStatus = (payload: UpdateLenderAicaChaseStatusPayload) => {
    return axios({
        url: `${polusBaseUrl}/unifier/updateAicaChaseStatus`,
        method: POST,
        data: {
            requestPayload: payload,
        },
    }).then((response) => {
        // Extract data from the nested responseBody and wrap it in data object
        if (response.data && response.data.responseBody && response.data.responseBody.data) {
            return {
                data: response.data.responseBody,
            };
        }
        return response.data;
    });
};

const API_ENDPOINTS = {
    GET_LENDER_REQUIREMENTS: 'dealRunner/getLenderRequirements',
    UPDATE_LENDER_REQUIREMENTS: 'dealRunner/updateRequirements',
    ADD_LENDER_REQUIREMENTS: 'dealRunner/createRequirement',
    REFRESH_REQUIREMENTS_AS_OF_TODAY: 'dealRunner/refreshRequirementAsOfToday',
    GET_BORROWER_REQUIREMENTS: 'dealRunner/getBorrowerRequirements',
    UPDATE_AICA_CHASE_STATUS: 'dealRunner/updateAicaChaseStatus',
    UPDATE_LENDER_AICA_CHASE_STATUS: 'rest/unifier/updateAicaChaseStatus',
    POPULATE_REQUEST_FOR_PNO_CONFIG: 'dealRunner/populateRequestForPnoConfig',
};
